let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4cS57")).then(() => parcelRequire('3jte6'));